<template>
    <svg width="30px" height="30px" viewBox="0 0 64 64" id="wallet-pay" xmlns="http://www.w3.org/2000/svg" fill="#000000">

        <g id="SVGRepo_bgCarrier" stroke-width="0"/>
        
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
        
        <g id="SVGRepo_iconCarrier">
        
        <defs>
        
  
        
        </defs>
        
        <title/>
        
        <path class="cls-1" d="M52,9.39V25L4.22,18a2.92,2.92,0,0,1,1.83-1.75L42.25,2.42l.09,0A8.23,8.23,0,0,1,45,2h0a6.81,6.81,0,0,1,4.83,2A7.52,7.52,0,0,1,52,9.39Z"/>
        
        <path class="cls-2" d="M54,18H25c-.1,0-.2,0-.3,0H4.22a3.38,3.38,0,0,0-.11.34A2.08,2.08,0,0,0,4,19V53a6,6,0,0,0,6,6H54a6,6,0,0,0,6-6V24A6,6,0,0,0,54,18Z"/>
        
        <path class="cls-3" d="M60,30V48H44a4,4,0,0,1-4-4V34a4,4,0,0,1,4-4Z"/>
        
        <circle class="cls-1" cx="48" cy="39" r="3"/>
        
        </g>
        
        </svg>
</template>
<style scoped>
.cls-1{fill:#8e7c15;}
.cls-2{fill:#CCAF12;}
.cls-3{fill:#016B00;}
</style>